import { API_BASE_URL, API_CREATE_EXAM_PATH } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export interface getCreateExamResponse {
    create_exam_status: string;
    exam_uuid: string;
}

async function executeGetCreateExamWithToken(accessToken: string | null): Promise<getCreateExamResponse> {
    return axios
        .get(
            API_BASE_URL + API_CREATE_EXAM_PATH,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 201) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetCreateExamWithToken(accessToken: string | null): Promise<getCreateExamResponse> {

    return executeGetCreateExamWithToken(accessToken)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetCreateExamWithToken(refreshedAccessToken);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
